export default __webpack_public_path__ + "static/media/howWeWorkBanner.a8112c1a.jpg";